<div class="row pt-2">
  <div class="col-12">
    <div class="report-filter-panel">
      <div class="report-title-block">
        <h6 class="HeadContent mb-0 report-title">Validate External references in question</h6>
      </div>

      <div class="report-filter-fields-wrap ms-auto">
        <div class="report-filter-fields">
          <div class="report-filter-item">
            <label for="subjectId" class="report-filter-label">Subject</label>
            <select
              id="subjectId"
              class="form-select form-select-sm report-filter-control"
              [(ngModel)]="selectedSubjectId"
              (ngModelChange)="onSubjectChange()"
              [disabled]="isLoading"
            >
              <option *ngFor="let s of subjectList" [ngValue]="s.ID">{{ s.Name }}</option>
            </select>
          </div>

          <div class="report-filter-item">
            <label for="whereToSearch" class="report-filter-label">Where To Search</label>
            <select
              id="whereToSearch"
              class="form-select form-select-sm report-filter-control"
              [(ngModel)]="selectedWhereToSearch"
              (ngModelChange)="onWhereToSearchChange()"
              [disabled]="isLoading || !selectedSubjectId"
            >
              <option *ngFor="let option of whereToSearchOptions" [ngValue]="option">
                {{ option }}
              </option>
            </select>
          </div>

          <div class="report-filter-item">
            <label for="questionId" class="report-filter-label">Question ID</label>
            <input
              id="questionId"
              type="text"
              class="form-control form-control-sm report-filter-control"
              [(ngModel)]="questionId"
              [disabled]="isLoading"
              placeholder="Enter question ID"
            />
          </div>

          <div class="report-filter-item">
            <label for="searchString" class="report-filter-label">Search String</label>
            <input
              id="searchString"
              type="text"
              class="form-control form-control-sm report-filter-control"
              [value]="searchString"
              readonly
              disabled
            />
          </div>

          <div class="report-filter-item">
            <label for="stringToExclude" class="report-filter-label">String To Exclude</label>
            <input
              id="stringToExclude"
              type="text"
              class="form-control form-control-sm report-filter-control"
              [value]="stringToExclude"
              readonly
              disabled
            />
          </div>
        </div>

        <div class="d-flex gap-2">
          <button
            class="btn btn-sm bl-btn report-filter-btn"
            type="button"
            (click)="fetchReport()"
            [disabled]="isLoading"
          >
            {{ isLoading ? "Loading..." : "Search" }}
          </button>
          <button
            class="btn btn-sm btn-outline-secondary report-filter-btn"
            type="button"
            (click)="clearFilters()"
            [disabled]="isLoading"
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row pt-2">
  <div class="col-12">
    <div class="table-responsive report-table-wrapper">
      <table class="table table-striped table-bordered table-sm">
        <thead>
          <tr class="table-secondary">
            <th class="text-center">Question ID</th>
            <th class="text-center">Created By</th>
            <th class="text-center">Src Value</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of reportRows">
            <td>
              <a
                href=""
                class="report-question-link"
                (click)="openQuestionEditor(row, $event)"
              >
                {{ row.Question_ID }}
              </a>
            </td>
            <td>{{ row.Created_By }}</td>
            <td>
              <a [href]="row.SrcValue" target="_blank" rel="noopener noreferrer" class="report-question-link">
                {{ row.SrcValue }}
              </a>
            </td>
          </tr>
          <tr *ngIf="!isLoading && reportRows.length === 0">
            <td colspan="3" class="text-center">No records found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-question-list
  #questionEditorHost
  [Questionlistresponse]="editorQuestionListResponse"
  [ScreenName1]="'editquestion'"
  [questionsubjectresponse]="editorQuestionSubjectResponse"
  [subjectById]="editorSubjectById"
></app-question-list>
